import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Bell, Check } from 'lucide-react';
import api, { formatApiError } from '@/lib/api';
import Layout from '@/components/Layout';
import { Button } from '@/components/ui/button';

export default function Notifications() {
	const [items, setItems] = useState([]);
	const [loading, setLoading] = useState(true);

	const load = async () => {
		try {
			const { data } = await api.get('/notifications');
			setItems(data.items || []);
		} catch (err) {
			toast.error(formatApiError(err));
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => { load(); }, []);

	const markRead = async (id) => {
		try {
			await api.post(`/notifications/${id}/read`);
			setItems((arr) => arr.map((n) => n.notification_id === id ? { ...n, read: true } : n));
		} catch (err) {
			toast.error(formatApiError(err));
		}
	};

	return (
		<Layout>
			<div className="max-w-2xl">
				<h1 className="text-3xl sm:text-4xl font-heading font-bold tracking-tight text-slate-900">Notifications</h1>
				<p className="mt-2 text-slate-600">Friendly nudges to keep your family resilience growing.</p>

				<div className="mt-8 space-y-3">
					{loading && <div className="card-soft p-6 text-slate-500">Loading…</div>}
					{!loading && items.length === 0 && (
						<div className="card-soft p-8 text-center text-slate-500">
							<Bell className="w-6 h-6 mx-auto mb-2 text-slate-400" />
							You&apos;re all caught up.
						</div>
					)}
					{items.map((n) => (
						<div key={n.notification_id} className={`card-soft p-5 flex items-start gap-4 ${n.read ? 'opacity-70' : ''}`}>
							<div className="w-10 h-10 rounded-2xl bg-emerald-100 text-emerald-700 grid place-items-center shrink-0">
								<Bell className="w-5 h-5" />
							</div>
							<div className="flex-1 min-w-0">
								<div className="font-heading font-semibold text-slate-900">{n.title}</div>
								<div className="text-sm text-slate-600 mt-0.5">{n.body}</div>
								<div className="text-xs text-slate-400 mt-2">{new Date(n.created_at).toLocaleString()}</div>
							</div>
							{!n.read && (
								<Button size="sm" variant="ghost" onClick={() => markRead(n.notification_id)} className="rounded-full">
									<Check className="w-4 h-4 mr-1" /> Read
								</Button>
							)}
						</div>
					))}
				</div>
			</div>
		</Layout>
	);
}
